import mustache from "mustache";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { RecipientesRender } from "../list/RecipientesRender";
import template from "./aplicacionesConfiguracionContentTemplate.html";

mustache.parse(template);

/** Cuerpo del modal de configuración de aplicaciones: apila las secciones en un
 *  contenedor scrolleable, cada una como una card — mismo patrón que
 *  `MonitoreoConfiguracionContentRender`.
 *
 *  Hoy tiene una sola sección (recipientes). Se arma igual que el de monitoreo,
 *  con contenedor y divisores, porque el módulo va a sumar más configuración y
 *  así la segunda sección entra sin rehacer la pantalla. */
export class AplicacionesConfiguracionContentRender implements IConnectRender {
  /** Sección de recipientes (canecas, tanques). */
  private readonly _recipientes: RecipientesRender = new RecipientesRender();

  render(): string {
    return mustache.render(template, {
      recipientes: this._recipientes.render(),
    });
  }

  connect(): void {
    this._recipientes.connect();
  }

  dispose(): void {
    this._recipientes.dispose();
  }
}
